// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "pdfjs" + "-legacy." + "03de845d" + ".js";
};